import { render } from "./EmailSignature.vue?vue&type=template&id=ade7849a&scoped=true"
import script from "./EmailSignature.vue?vue&type=script&lang=js"
export * from "./EmailSignature.vue?vue&type=script&lang=js"

import "./EmailSignature.vue?vue&type=style&index=0&id=ade7849a&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ade7849a"]])

export default __exports__